import React from "react";

const IconDescription = ({ size = 24, color = "var(--primary-text-color)", ...rest }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            viewBox="0 0 24 24"
            width={`${size}px`}
            fill={color}
            {...rest}
        >
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"/>
        </svg>
    )
}

export default IconDescription;
